export default {"src":"/_next/static/media/hassle_free.e5d13de1.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};